import { toast } from 'react-toastify';
import styled from 'styled-components';

import Icon from '../components/Icon';

import Layout from '../layout/Layout2020';

const StyledIcon = styled(Icon)`
  margin-right: 10px;
  & > i, & > span {
    color: ${({ color }) => (color)} !important;
  }
`;

export const showSuccess = (message, dataTest) => {
  toast.success(message, {
    toastId: dataTest,
    icon: () => (
      <StyledIcon
        color={'white'}
        margin={Layout.margin}
        iconLib={'material'}
        icon={'check'}
      />
    )
  });
};

export const showError = (message, dataTest) => {
  toast.error(message, {
    toastId: dataTest,
    icon: () => (
      <StyledIcon
        color={'white'}
        margin={Layout.margin}
        iconLib={'material'}
        icon={'error'}
      />
    )
  });
};

export const showInfo = (message, dataTest, options = {}) => {
  toast.info(message, {
    toastId: dataTest,
    icon: () => (
      <StyledIcon
        color={'black'}
        margin={Layout.margin}
        iconLib={'material'}
        icon={'warning_amber'}
      />
    ),
    // e.g. { autoClose: false } for a toast that stays until dismissed explicitly.
    ...options,
  });
};

// Amber "heads-up" toast (styled via .Toastify__toast--warning in app.js), for
// something the user must act on or wait for rather than a neutral notice.
export const showWarning = (message, dataTest, options = {}) => {
  toast.warning(message, {
    toastId: dataTest,
    icon: () => (
      <StyledIcon
        color={'#45446b'}
        margin={Layout.margin}
        iconLib={'material'}
        icon={'warning_amber'}
      />
    ),
    ...options,
  });
};

export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};

export default {
  showSuccess,
  showError,
  showInfo,
  showWarning,
  dismissToast,
};
